<template>
  <div>
    <div class="relative aspect-video w-full">
      <iframe
        :id="id"
        :src="videoUrl"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        :title="videoTitle"></iframe>
    </div>
    <div ref="script"></div>
  </div>
</template>

<script>
export default {
  props: {
    videoTitle: {
      type: String,
      required: true,
    },
    videoId: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    const videoUrl =
      "https://player.vimeo.com/video/" +
      props.videoId +
      "?h=bf84d5fa44&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";

    return {
      videoUrl,
    };
  },
};
</script>
